var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSessioni(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4084 20.3333L20.772 19.5447C22.3247 18.6462 23.1004 18.197 23.2044 17.5571C23.2198 17.4573 23.2246 17.3561 23.2188 17.2552C23.1668 16.611 22.4302 16.1141 20.9583 15.1203M20.9583 15.1203L14.1593 10.5313M20.9583 15.1203L17.9828 13.1111C16.9811 14.4074 16.1239 15.8091 15.4261 17.2913C14.7906 18.6303 14.4742 19.2991 14.5335 20.0647L10.2218 18.8889M14.1593 10.5313C11.4885 8.72867 10.8746 5.44111 12.7495 3M14.1593 10.5313C10.5482 14.1424 8.77734 24.1351 8.77734 29M14.1593 10.5313L17.9813 13.1111M20.3329 29C18.9275 27.3606 17.4816 25.1 16.0718 23.0171C15.0852 21.5582 14.5912 20.8273 14.5335 20.0632M21.7773 6.61111C21.7773 7.18575 21.549 7.73685 21.1427 8.14318C20.7364 8.54951 20.1853 8.77778 19.6106 8.77778C19.036 8.77778 18.4849 8.54951 18.0786 8.14318C17.6722 7.73685 17.444 7.18575 17.444 6.61111C17.444 6.03648 17.6722 5.48538 18.0786 5.07905C18.4849 4.67272 19.036 4.44444 19.6106 4.44444C20.1853 4.44444 20.7364 4.67272 21.1427 5.07905C21.549 5.48538 21.7773 6.03648 21.7773 6.61111Z",
    stroke: "#191E1B",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSessioni);
export default __webpack_public_path__ + "static/media/sessioni.9a58b5dc208f8e0d858944fb65ef9f10.svg";
export { ForwardRef as ReactComponent };